export default function SignatureOrderTexts({ data, className, roles, isMobileTable }: any) {

  const isPhysician = roles?.includes?.("Physician");

  // Normalize data so the component works with a single object or an array
  const orders = Array.isArray(data) ? data : data ? [data] : [];
  const hasPendingOrderAuthorization = orders.some(
    (order: any) => order?.orderStatus === "Pending Order Authorization"
  );

  const pendingOrderAuthDisclaimer =
    "This signature confirms the Esopredict® test to be medically necessary for this patient. This clinician provides consultation and/or treatment for the diagnosis and will use results in the management of the patient. This clinician further acknowledges that any information derived from Castle Biosciences testing will not be used for research or test development without providing prior written notice to Castle Biosciences and receiving written acknowledgment in response. Any unauthorized use may be prohibited by applicable laws and regulations, including those implemented by the U.S. Food and Drug Administration.";

  return (
    <div
      className={`w-full md:w-[350px] lg:w-[600px] max-h-[170px] md:max-h-[350px] overflow-auto bg-sideNavGray p-4 rounded-lg border border-roundedInputBorder mb-6 ${className}`}
    >
      {hasPendingOrderAuthorization && (
        <p className="text-sm text-royalBlue mb-4 max-w-prose">
          {pendingOrderAuthDisclaimer}
        </p>
      )}
      <ol>
        <h3 className="mb-3 text-sm">
          {isPhysician
            ? " My signature below confirms my intention to order"
            : "Physician signature confirms my intention to order:"}
        </h3>
        {orders.map((order: any, index: number) => {
          const testName = isMobileTable
            ? order?.testTypes?.limsTestName ?? order?.testType?.limsTestName
            : order?.testType?.limsTestName ?? order?.testTypes?.limsTestName;
          const patientName = order?.patientName ?? order?.patientInfo?.firstName ?? "";
          const dob = order?.patientInfo?.dateOfBirth ?? "";
          const key = `${order?.id ?? index}-${testName ?? index}`;

          return (
            <li className="mb-6" key={key}>
              <p className="text-sm">
                <span className="text-primary">{index + 1}. </span>
                <strong>{testName}</strong> for {" "}
                <strong>
                  {patientName} {dob}
                </strong>
              </p>
            </li>
          );
        })}
      </ol>
    </div>
  );
}